import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import RedoIcon from "@mui/icons-material/Redo";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  TextField,
  Popper,
  Paper,
  ClickAwayListener,
  Chip,
  InputAdornment,
  Tooltip,
  Checkbox,
  Collapse,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";

import SearchBar2 from "../../components/SearchBar2";
import {
  useEditUserMutation,
  useDeleteByIduserMutation,
  useLazyGetAllUserQuery,
} from "../../services/users";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import { errorToast, successToast } from "../../helpers/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import { useLazyExportUserCsvQuery } from "../../services/dashboard";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  getEnquriesCount,
  getFeedbackCount,
  getLeadsCount,
  getNewListingActionTracker,
  getNewPropertyListing,
  getNewPropertyReports,
  getNewUsers,
  getRecentNotificationCount,
  setNotificationCount,
} from "../../reducers/generalSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { useResendCredsMutation } from "../../services/auth";
import EditKeyModal from "../../components/EditWarnModal";
import { ROLE } from "../../constants/enums";
import ResendCredsWarning from "../../components/ResendCreds";

const ManageUsers = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const newNotificationCount = useAppSelector(getRecentNotificationCount);
  const newPropertyReports = useAppSelector(getNewPropertyReports);
  const newPropertyListing = useAppSelector(getNewPropertyListing);
  const newListingActionTracker = useAppSelector(getNewListingActionTracker);
  const newEnquries = useAppSelector(getEnquriesCount);
  const newFeedback = useAppSelector(getFeedbackCount);
  const newLeadsCount = useAppSelector(getLeadsCount);

  const [resendCredsApi] = useResendCredsMutation();
  const role = ROLE.INDIVIDUAL_USER;
  const [getallusers] = useLazyGetAllUserQuery();
  const [rows, setRows] = useState<any>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);
  const [editUSERbyId] = useEditUserMutation();
  const [deleteUserById] = useDeleteByIduserMutation();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [exportCsv] = useLazyExportUserCsvQuery();
  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const ResendCreds = async () => {
    try {
      const res = await resendCredsApi({ id: selectedId }).unwrap();
      if (res?.statusCode === 200) {
        successToast("Credentials sent successfully");
      }
    } catch (error: any) {
      errorToast(error?.data?.message);
    }
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const handleExportCsv = async () => {
    setIsLoading(true);
    try {
      const res = await exportCsv({
        startDate: range?.from
          ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
        endDate:
          range?.to === range?.from
            ? ""
            : range?.to
              ? moment(range?.to).endOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
              : "",
        search: debouncedSearchTerm?.trim(),
      }).unwrap();
      if (res?.statusCode === 200) {
        setIsLoading(false);
        window.open(res?.data);
        successToast("CSV exported successfully");
      } else {
        errorToast("Error: s3Location not found in response");
      }
    } catch (error: any) {
      setIsLoading(false);
      errorToast(error?.message || error?.data?.message);
    }
  };

  const fetchData = async (role: number, page: number, search: string) => {
    setIsLoading(true);
    try {
      const response = await getallusers({
        page: page,
        search: search,
        limit: limit,
        role: ROLE.INDIVIDUAL_USER,
        startDate: range?.from
          ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
        endDate: range?.to
          ? moment(range?.to).endOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
      }).unwrap();
      if (response.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.user || []);
        setTotalCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };
  const handleDeleteUser = async (userId: any) => {
    setIsLoading(true);
    try {
      const response = await deleteUserById({ userId }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        successToast("User deleted successfully");
        fetchData(role, page, debouncedSearchTerm);
      }
    } catch (error: any) {
      console.error(error);
      setIsLoading(false);
      errorToast(error?.message || error?.data?.message || "");
    }
  };
  const changeUserStatus = async (userId: string, userStatus: boolean) => {
    setIsLoading(true);
    try {
      let body = {
        isBlocked: String(userStatus),
      };
      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await editUSERbyId({
        body: encryptedBody,
        id: userId,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        successToast("Status updated successfully");
      }
    } catch (error: any) {
      setIsLoading(false);
      errorToast(error?.message || error?.data?.message);
      console.error(error);
    }
  };

  const naviagteFunc = () => {
    navigate(`/manage-users/usersform/${selectedId}`);
  };

  useEffect(() => {
    fetchData(role, page, debouncedSearchTerm);
  }, [role, page, debouncedSearchTerm, limit, range]);

  useEffect(() => {
    // //console.log(moment("2024-12-02T18:30:00Z").format("DD:MM:YYYY"), "result");

    dispatch(
      setNotificationCount({
        newNotificationCount: newNotificationCount,
        newUsers: 0,
        newPropertyListing: newPropertyListing,
        newPropertyReports: newPropertyReports,
        newListingActionTracker: newListingActionTracker,
        newEnquriesCount: newEnquries,
        newFeedbackCount: newFeedback,
        leadsCount: newLeadsCount,
      })
    );
  }, []);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_layout">
        <div className="dashboard">
          <h2 className="mn_hdng">Manage Users</h2>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                    setTimeout(() => {
                      setPage(1);
                    }, 1000);
                  }
                }}
              />
              <div className="control_group">
                <TextField
                  // label="Select Date Range"
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  fullWidth
                  onClick={handleClick}
                  value={getFormattedRange()}
                  placeholder="Select Date Range"
                  InputProps={{
                    readOnly: true,
                    endAdornment: range?.from ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setRange({
                              from: undefined,
                              to: undefined,
                            });
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : (
                      <InputAdornment position="end">
                        <IconButton>
                          <CalendarTodayIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <Popper
                open={open1}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper
                    elevation={3}
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      style={{
                        padding: 16,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Chip
                          label="Last Week"
                          variant={
                            selectedChip === "lastWeek" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastWeek")}
                        />
                        <Chip
                          label="Last Month"
                          variant={
                            selectedChip === "lastMonth" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastMonth")}
                        />
                        <Chip
                          label="Last Year"
                          variant={
                            selectedChip === "lastYear" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastYear")}
                        />
                      </div>

                      <DayPicker
                        className="react-day-picker"
                        mode="range"
                        selected={range}
                        onSelect={handleSelect}
                        // numberOfMonths={10}

                        month={month}
                        onMonthChange={handleMonthChange}
                      />
                    </div>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Box>
            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-users/usersform")}
              >
                <AddIcon /> Add User
              </Button>
              <Tooltip title="Download record">
                <Button
                  className="btn btn_primary"
                  onClick={handleExportCsv}
                  disabled={rows?.length === 0 ? true : false}
                >
                  <FileDownloadIcon /> Export CSV
                </Button>
              </Tooltip>
            </Box>
          </Box>

          <Box
            className="table_container"
            sx={{ height: "600px", overflowY: "auto" }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="center">Actions</TableCell>
                  <TableCell>User Id</TableCell>
                  <TableCell>Full name</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Date & time</TableCell>
                  <TableCell>Account Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!rows?.length ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No user found
                    </TableCell>
                  </TableRow>
                ) : (
                  rows?.map((row: any, i: any) => (
                    <TableRow key={row?._id}>
                      <TableCell align="center">
                        {(page - 1) * 10 + i + 1}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <Tooltip title="View details">
                            <IconButton
                              onClick={() =>
                                navigate(`/manage-users/details/${row?._id}`)
                              }
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit user details">
                            <IconButton
                              onClick={
                                () => {
                                  setOpenEdit(true);
                                  setSelectedId(row?._id);
                                }
                                // navigate(`/manage-users/usersform/${row?._id}`)
                              }
                            >
                              <ModeEditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Send credentials to user again">
                            <IconButton
                              onClick={() => {
                                setSelectedId(row?._id);
                                setOpenWarn(true);
                              }}
                            >
                              <RedoIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete user">
                            <IconButton
                              onClick={() => {
                                setOpen(true);
                                setSelectedId(row?._id);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                      <TableCell>{row?.referenceId || "-"}</TableCell>

                      <TableCell>{row?.name || "-"}</TableCell>
                      <TableCell>
                        {row?.dialCode + row?.phoneNo || "-"}
                      </TableCell>
                      <TableCell>{row?.email || "-"}</TableCell>
                      <TableCell>
                        {row?.createdAt
                          ? moment(row?.createdAt).format("LLL")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        <Switch
                          defaultChecked={!row.isBlocked}
                          onChange={(e) => {
                            const isChecked = !e.target.checked;
                            changeUserStatus(row._id, isChecked);
                          }}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Box>
        </Card>
      </div>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          limit={limit}
          setLimit={setLimit}
        />
      ) : (
        ""
      )}
      <ResendCredsWarning
        open={openWarn}
        setOpen={setOpenWarn}
        func={ResendCreds}
      />
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteUser(selectedId)}
        name="User"
      />
      <EditKeyModal
        open={openEdit}
        setOpen={setOpenEdit}
        navigate={naviagteFunc}
      />
    </div>
  );
};

export default ManageUsers;
